<template>
  <v-app>
    <div v-if="auth.loading">{{ t('common.loading') }}</div>
    <div v-else>
      <router-view />

      <PWAUpdatePrompt />
    </div>
  </v-app>
</template>

<script setup lang="ts">
  import { useI18n } from 'vue-i18n';

  import { useAuthStore } from '@/features/auth/store/auth';
  import { useLanguageSync } from '@/shared/composables/useLanguageSync';

  import PWAUpdatePrompt from '@/core/components/PWAUpdatePrompt.vue';

  const { t } = useI18n();

  const auth = useAuthStore()

  useLanguageSync()
</script>
